import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ItemDetailsDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  margin-top: 20px;

  ${media.lg`
    padding-left: 60px;
    margin-top: 0;
  `}
`;

export const DescriptionWrapper = styled.div`
  max-width: 760px;
  padding: 20px 0;
  font-weight: bold;
`;
